<template>
  <div>
    <vs-prompt
      @cancel="createCopyPromptActive = false"
      @close="createCopyPromptActive = false"
      @accept="createCopy"
      title="Copy meeting"
      accept-text="Copy meeting"
      :active.sync="createCopyPromptActive"
    >
      <div>
        <vs-input class="w-full" placeholder="Meeting title" label="New meeting display title" v-model="newMeetingTitle" />
        <vs-select v-model="newMeetingCountry" class="w-full mt-2" label="New list country">
          <vs-select-item :key="index" :value="item.id.toUpperCase()" :text="item.name" v-for="(item, index) in countries" />
        </vs-select>
        <vs-select v-model="newMeetingType" label="New list frequency type" class="w-full mt-2">
          <vs-select-item v-for="item in meetingFrequencyTypes" :key="item" :value="item" :text="item" />
        </vs-select>
      </div>
    </vs-prompt>
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-4/5 w-full">
          <h2 style="font-size: revert; font-weight: 500">
            {{ meeting.title }}
          </h2>
          <h5>General info</h5>
        </div>
      </div>

      <div class="flex flex-col gap-6">

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Enabled</span>
          </div>
          <div class="flex-grow">
            <vs-switch v-model="meeting.enabled" />
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Meeting title</span>
          </div>
          <div class="flex-grow">
            <vs-input v-model="meeting.title" />
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Meeting repeat frequency</span>
          </div>
          <div class="flex-grow">
            <code>{{ meeting.type }}</code>
            <!-- <vs-select v-model="meeting.type">
              <vs-select-item v-for="item in meetingFrequencyTypes" :key="item" :value="item" :text="item" />
            </vs-select> -->
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Allowed Venues</span>
          </div>
          <div style="width: 400px">
            <VenueSelector 
              v-model="meeting.allowedVenueIds" 
              :multiple="true" 
              :filterCountries="[activeCountry.name]"
              placeholder="Select venues that can take this meeting"
              class="w-full"
            />
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Initial attendees of meeting</span>
          </div>
          <div class="flex-grow">
            <vs-select multiple autocomplete v-model="meeting.initialAttendeesIdamRoles" class="w-full">
              <vs-select-item :key="role.id" v-for="role in roles" :value="role.id" :text="role.title + ' (' + role.id + ')'" />
            </vs-select>
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Shown in the meeting</span>
          </div>
          <div class="flex-grow flex flex-col gap-3">
            <div class="flex items-center gap-3" v-for="option in displayOptions" :key="option.key">
              <vs-switch v-model="meeting.display[option.key]" />
              <span>{{ option.label }}</span>
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Meeting purpose description</span>
          </div>
          <div class="flex-grow">
            <quill-editor class="editor" v-model="meeting.description.purpose"></quill-editor>
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Meeting participants description</span>
          </div>
          <div class="flex-grow">
            <quill-editor class="editor" v-model="meeting.description.participants"></quill-editor>
          </div>
        </div>

        <div class="flex">
          <div class="w-64 flex-shrink-0">
            <span>Meeting other info</span>
          </div>
          <div class="flex-grow">
            <quill-editor class="editor" v-model="meeting.description.otherInformation"></quill-editor>
          </div>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row vs-justify="space-between" class="flex flex-wrap items-center mt-6" v-if="hasPermission('vp.life.meetings.edit')">
        <vs-button v-if="hasPermission('vp.life.meetings.edit')" @click="$emit('update:meeting')">Save</vs-button>
        <div class="flex gap-2">
          <vs-button v-if="hasPermission('vp.life.meetings.edit')" @click="createCopyPromptActive = true">Create copy of meeting</vs-button>
          <vs-button v-if="hasPermission('vp.life.meetings.edit')" color="danger" type="border" @click="confirmDelete">Delete meeting</vs-button>
        </div>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: { quillEditor, VenueSelector },
  props: {
    meeting: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      createCopyPromptActive: false,

      newMeetingTitle: this.meeting.title + " copy",
      newMeetingCountry: this.meeting.country,
      newMeetingType: this.meeting.type,

      displayOptions: [
        { key: "showPurpose", label: "Purpose" },
        { key: "showParticipants", label: "Participants" },
        { key: "showOtherInformation", label: "Other information" },
        { key: "showAgenda", label: "Agenda step" },
        { key: "showFinalReview", label: "Final review steps (\"You are almost done\" / \"Please elaborate\")" }
      ]
    };
  },
  mounted() {
    // Ensure allowedVenueIds is initialized
    if (!this.meeting.allowedVenueIds) {
      this.$set(this.meeting, 'allowedVenueIds', []);
    }
  },
  watch: {
    meeting: {
      handler(newMeeting) {
        // Ensure allowedVenueIds is initialized when meeting changes
        if (newMeeting && !newMeeting.allowedVenueIds) {
          this.$set(newMeeting, 'allowedVenueIds', []);
        }
        // Older meetings have no display settings: everything is shown
        if (newMeeting) {
          if (!newMeeting.display) this.$set(newMeeting, "display", {});
          this.displayOptions.forEach(option => {
            if (typeof newMeeting.display[option.key] !== "boolean") this.$set(newMeeting.display, option.key, true);
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete meeting",
        text: `Are you sure you want to delete '${this.meeting.title}'? Only the meeting in Rekom Life is deleted. Google Drive files and held meetings are kept.`,
        acceptText: "Delete",
        accept: this.deleteMeeting
      });
    },
    async deleteMeeting() {
      try {
        this.$vs.loading();
        await this.$store.dispatch("meetings/deleteMeeting", this.meeting.id);
        this.$vs.notify({
          color: "success",
          title: "Deleted",
          text: "Meeting deleted"
        });
        this.$router.push({ name: "manage-meetings" });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not delete meeting",
          text: err
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onClickCopy() {
      this.createCopyPromptActive = true;
    },
    async createCopy() {
      try {
        this.$vs.loading();
        console.log("Creating copy of meeting", this.meeting);
        var newMeetingId = await this.$store.dispatch("meetings/createCopy", {
          copyMeetingId: this.meeting.id,
          newMeetingTitle: this.newMeetingTitle,
          newMeetingCountry: this.newMeetingCountry,
          newMeetingFrequencyType: this.newMeetingType
        });
        this.$vs.notify({
          color: "success",
          title: "Copy",
          text: "Succesfully created copy of meeting"
        });

        // Route to lists
        this.$router.push({ name: "manage-meetings" });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not create copy",
          text: err
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  },
  computed: {
    ...mapGetters({
      roles: "roles",
      meetingFrequencyTypes: "meetings/meetingFrequencyTypes",
      countries: "venues/countries",
      activeCountry: "venues/activeCountry"
    })
  }
};
</script>
